/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { FcbRepresentantGridDto } from './FcbRepresentantGridDto';
import {
    FcbRepresentantGridDtoFromJSON,
    FcbRepresentantGridDtoFromJSONTyped,
    FcbRepresentantGridDtoToJSON,
} from './FcbRepresentantGridDto';
import type { IAggregateResult } from './IAggregateResult';
import {
    IAggregateResultFromJSON,
    IAggregateResultFromJSONTyped,
    IAggregateResultToJSON,
} from './IAggregateResult';

/**
 * 
 * @export
 * @interface FcbRepresentantGridDtoPaginatedResults
 */
export interface FcbRepresentantGridDtoPaginatedResults {
    /**
     * 
     * @type {number}
     * @memberof FcbRepresentantGridDtoPaginatedResults
     */
    totalCount?: number;
    /**
     * 
     * @type {Array<FcbRepresentantGridDto>}
     * @memberof FcbRepresentantGridDtoPaginatedResults
     */
    results?: Array<FcbRepresentantGridDto> | null;
    /**
     * 
     * @type {Array<IAggregateResult>}
     * @memberof FcbRepresentantGridDtoPaginatedResults
     */
    aggregateResults?: Array<IAggregateResult> | null;
}

/**
 * Check if a given object implements the FcbRepresentantGridDtoPaginatedResults interface.
 */
export function instanceOfFcbRepresentantGridDtoPaginatedResults(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function FcbRepresentantGridDtoPaginatedResultsFromJSON(json: any): FcbRepresentantGridDtoPaginatedResults {
    return FcbRepresentantGridDtoPaginatedResultsFromJSONTyped(json, false);
}

export function FcbRepresentantGridDtoPaginatedResultsFromJSONTyped(json: any, ignoreDiscriminator: boolean): FcbRepresentantGridDtoPaginatedResults {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'totalCount': !exists(json, 'totalCount') ? undefined : json['totalCount'],
        'results': !exists(json, 'results') ? undefined : (json['results'] === null ? null : (json['results'] as Array<any>).map(FcbRepresentantGridDtoFromJSON)),
        'aggregateResults': !exists(json, 'aggregateResults') ? undefined : (json['aggregateResults'] === null ? null : (json['aggregateResults'] as Array<any>).map(IAggregateResultFromJSON)),
    };
}

export function FcbRepresentantGridDtoPaginatedResultsToJSON(value?: FcbRepresentantGridDtoPaginatedResults | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'totalCount': value.totalCount,
        'results': value.results === undefined ? undefined : (value.results === null ? null : (value.results as Array<any>).map(FcbRepresentantGridDtoToJSON)),
        'aggregateResults': value.aggregateResults === undefined ? undefined : (value.aggregateResults === null ? null : (value.aggregateResults as Array<any>).map(IAggregateResultToJSON)),
    };
}

